import { useDebounce } from '~/hooks'
import { useWstEth2StEthRate } from './useWstEth2StEthRate'

export const useWithdrawalReceiveAmount = (
  isSelectedStETH: boolean,
  amount: string,
) => {
  const debouncedAmount = useDebounce(amount || '0', 500)
  const { rate, isValidating } = useWstEth2StEthRate(debouncedAmount)
  return {
    receiveAmount: isSelectedStETH ? debouncedAmount : rate,
    isValidating: isSelectedStETH ? false : isValidating,
  }
}
